export default function initPopups() {
  document.querySelectorAll('[data-popup]').forEach((link)=>{
    const popup = document.querySelector(link.dataset.popup);
    const classOpened = 'popup-opened';
    if(!popup) return;
    const close = popup.querySelector('[data-popup-close]');

    link.addEventListener('click', (e)=>{
      e.preventDefault();
      popup.classList.add(classOpened);
      document.body.classList.add(classOpened);
    });

    close.addEventListener('click', (e)=> {
      e.preventDefault();
      document.body.classList.remove(classOpened);
      popup.classList.remove(classOpened);
    });
  });
}